import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { I18nProvider } from './i18n';
import ShopHome from './pages/ShopHome';
import ShopPage from './pages/ShopPage';
import PurchasePage from './pages/PurchasePage';
import CheckoutPage from './pages/CheckoutPage';
import SuccessPage from './pages/SuccessPage';
import CancelPage from './pages/CancelPage';
import ViewVoucherPage from './pages/ViewVoucherPage';
import LegalPage from './pages/LegalPage';
import CompanyDetailsPage from './pages/CompanyDetailsPage';
import VoucherVatHelpPage from './pages/VoucherVatHelpPage';
import './index.css';

function App() {
  return (
    <I18nProvider>
      <Routes>
        <Route path="/" element={<ShopHome />} />
        <Route path="/shop/:locationId" element={<ShopPage />} />
        <Route path="/shop/:locationId/purchase/:itemId" element={<PurchasePage />} />
        <Route path="/shop/:locationId/terms" element={<LegalPage kind="terms" />} />
        <Route path="/shop/:locationId/privacy" element={<LegalPage kind="privacy" />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/success/:purchaseId" element={<SuccessPage />} />
        <Route path="/voucher/:code?" element={<ViewVoucherPage />} />
        <Route path="/cancel" element={<CancelPage />} />
        <Route path="/company-details/:token" element={<CompanyDetailsPage />} />
        {/* Printed on every purchase confirmation PDF — keep these paths stable. */}
        <Route path="/help/en/gift-vouchers-and-vat" element={<VoucherVatHelpPage lang="en" />} />
        <Route path="/help/nl/cadeaubonnen-en-btw" element={<VoucherVatHelpPage lang="nl" />} />
      </Routes>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          // Ink on paper, like everything else on these pages.
          style: {
            background: '#1B1A17',
            color: '#F6F4F1',
            borderRadius: '3px',
            fontFamily: "'DM Sans', ui-sans-serif, system-ui, sans-serif",
            fontSize: '14px',
          },
          success: { duration: 3000 },
          error: { duration: 5000 },
        }}
      />
    </I18nProvider>
  );
}

export default App;

